import './change-runtime-comment.scss';

import keyBy from 'lodash/keyBy';
import { arrayOf } from 'prop-types';
import React from 'react';
import Moment from 'react-moment';
import { Badge, Label, Table } from 'reactstrap';

import {
  combineLinesByBusinesses,
  transformCampaignLine,
} from '../../campaign-editor/transform-for-rendering';
import withProducts from '../../products/withProducts/with-products';
import { changeRequestShape, productShape } from '../../prop-types';
import { UI_DATE_FORMAT } from '../../utils/constants';
import { getCampaignLineDiff } from '../utils';

function renderDateDiff(startDate, endDateCurrent, endDateNew) {
  return (
    <Table size="sm" className="mb-0">
      <tbody>
        <tr>
          <td className="pl-0">Current</td>
          <td>
            <Moment format={UI_DATE_FORMAT}>{startDate}</Moment>
          </td>
          <td>-</td>
          <td>
            <Moment format={UI_DATE_FORMAT}>{endDateCurrent}</Moment>
          </td>
        </tr>
        <tr>
          <td className="pl-0">New</td>
          <td>
            <Moment format={UI_DATE_FORMAT}>{startDate}</Moment>
          </td>
          <td>-</td>
          <td className="font-weight-bold">
            <Moment format={UI_DATE_FORMAT}>{endDateNew}</Moment>
          </td>
        </tr>
      </tbody>
    </Table>
  );
}

function renderCountryLines(product, campaignLinesById, changeRequest) {
  return product.countries.map(({ lines, label }) =>
    lines.map(lineId => {
      const line = campaignLinesById[lineId];
      const diffObject = getCampaignLineDiff(changeRequest, line);

      if (!diffObject) {
        return null;
      }

      const endDateDiff = diffObject.endDate;
      const { startDate } = line;
      const endDateCurrent = endDateDiff?.originValue;
      const endDateNew = endDateDiff?.draftValue;

      return (
        <div
          className="qa-campaign-line border rounded bg-light py-1 px-2 small my-2"
          data-line-id={lineId}
          key={lineId}
        >
          <div className="d-flex align-items-center mb-1">
            {label}
            <Badge color="info" className="ml-2">
              {line.gender}
            </Badge>
          </div>
          {renderDateDiff(startDate, endDateCurrent, endDateNew)}
        </div>
      );
    }),
  );
}

function ChangeRuntimeComment({ changeRequest, products }) {
  const transformedLines = changeRequest.draftCampaignLines.map(line =>
    transformCampaignLine(line, products),
  );
  const linesByBusinesses = combineLinesByBusinesses(transformedLines);
  const campaignLinesById = keyBy(changeRequest.draftCampaignLines, 'id');

  return (
    <div className="mt-2">
      {linesByBusinesses.map(businessLine => (
        <div key={businessLine.label} className="qa-business-line mb-4">
          <Label className="font-weight-bold mb-2">{businessLine.label}</Label>
          {businessLine.products.map(product => (
            <div key={product.label} className="qa-product-line mb-3">
              <Label className="m-0">{product.label}</Label>
              <div className="c-change-runtime-lines">
                {renderCountryLines(product, campaignLinesById, changeRequest)}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

ChangeRuntimeComment.propTypes = {
  products: arrayOf(productShape.isRequired).isRequired,
  changeRequest: changeRequestShape.isRequired,
};
export default withProducts({})(ChangeRuntimeComment);
